import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b23bb7e")

_pushScopeId("data-v-0b23bb7e")
const _hoisted_1 = { class: "SendedInvoicesList" }
const _hoisted_2 = { class: "SendedInvoicesList__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "SendedInvoicesList__list scroll green" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"list__header\" data-v-0b23bb7e><div class=\"list__row header\" data-v-0b23bb7e><div class=\"list__col first header\" data-v-0b23bb7e>Накладная</div><div class=\"list__col second header\" data-v-0b23bb7e>Направление</div><div class=\"list__col third header\" data-v-0b23bb7e>Статус доставки</div><div class=\"list__col fifth header\" data-v-0b23bb7e>Тип доставки</div><div class=\"list__col sixth header\" data-v-0b23bb7e>Дата создания</div><div class=\"list__col seventh header\" data-v-0b23bb7e></div></div></div>", 1)
const _hoisted_6 = { class: "list__body" }
const _hoisted_7 = { class: "list__col first col-big" }
const _hoisted_8 = { class: "list__col second" }
const _hoisted_9 = { class: "list__col third" }
const _hoisted_10 = { class: "list__col fifth" }
const _hoisted_11 = { class: "list__col sixth" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Подробнее ")
const _hoisted_13 = {
  key: 1,
  class: "list__row empty"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "list__col full" }, "Нет накладных", -1)
const _hoisted_15 = {
  key: 1,
  class: "SendedInvoicesList__loading"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_ltl_status = _resolveComponent("ltl-status")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.withRefresh)
        ? (_openBlock(), _createBlock(_component_icon_refresh, {
            key: 0,
            class: "header__refresh",
            onClick: _ctx.emitRefresh
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              (_ctx.invoices && _ctx.invoices.length > 0)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.invoices, (invoice, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "list__row",
                      key: `SendedInvoicesList-invoice-${i}`
                    }, [
                      _createVNode("div", _hoisted_7, _toDisplayString(invoice.number), 1),
                      _createVNode("div", _hoisted_8, _toDisplayString(invoice.direction.sender.city_name) + " - " + _toDisplayString(invoice.direction.receiver.city_name), 1),
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_ltl_status, {
                          "status-code": invoice.info.status_code,
                          "status-text": invoice.info.status_name,
                          "is-invoice": false
                        }, null, 8, ["status-code", "status-text"])
                      ]),
                      _createVNode("div", _hoisted_10, _toDisplayString(invoice.info.shipment_type), 1),
                      _createVNode("div", _hoisted_11, _toDisplayString(invoice.created_at), 1),
                      _createVNode(_component_router_link, {
                        to: `/invoice/${invoice.id}`,
                        class: "list__col seventh col-shadow"
                      }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock("div", _hoisted_13, [
                    _hoisted_14
                  ]))
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode(_component_s_loader)
        ]))
  ]))
})